import React, { useState } from 'react';
import { Row, Col, Card, Input, Button } from 'reactstrap';
import { connect } from 'react-redux';
import CustomModal from '../../../../../../../../../Components/Modals/CustomModal';
import Comment_Dark from '../../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Comment_Dark.svg';
import xlsxIcon from '../../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/xlsxIcon.svg';
import Download from '../../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Download.svg';
import Close from '../../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Close.svg';
import Send from '../../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Send.svg';
import TickMark from '../../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/TickMark.svg';
import Rename from '../../../../../../../../../../designUtils/Storeoverview/BuildBrand/AssetsGallery/Rename.svg';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faTrash,
  faTimes,
  faWindowClose,
  faFile,
  faFilePdf,
  faFileWord,
  faFileAlt,
  faFileArchive,
  faFileCode,
} from "@fortawesome/free-solid-svg-icons";
import addAssetNoteService from '../../../../../../../../../../Service/DashboardServices/AssetGalleryServices/addAssetNoteService';
import getAssetNoteService from '../../../../../../../../../../Service/DashboardServices/AssetGalleryServices/getAssetNoteService';
import RenameFileAssetNewService from '../../../../../../../../../../Service/DashboardServices/AssetGalleryServices/RenameFileAssetNewService';
import DeleteFileAssetNewService from '../../../../../../../../../../Service/DashboardServices/AssetGalleryServices/DeleteFileAssetNewService';

const IMAGE_EXTS = ['jpg', 'jpeg', 'png', 'gif', 'webp', 'bmp', 'svg', 'avif'];
const VIDEO_EXTS = ['mp4', 'mov', 'webm', 'avi', 'mkv'];
const EXCEL_EXTS = ['csv', 'xlsx', 'xls', 'xlsm'];

function getExtension(path) {
  const parts = (path || '').split('.');
  return (parts[parts.length - 1] || '').toLowerCase();
}

function getMediaType(path) {
  const ext = getExtension(path);
  if (IMAGE_EXTS.indexOf(ext) !== -1) return 'image';
  if (VIDEO_EXTS.indexOf(ext) !== -1) return 'video';
  return 'other';
}

function getFileIcon(path) {
  const ext = getExtension(path);
  if (ext === 'pdf') return faFilePdf;
  if (ext === 'doc' || ext === 'docx') return faFileWord;
  if (ext === 'txt' || ext === 'rtf') return faFileAlt;
  if (ext === 'zip' || ext === 'rar' || ext === '7z') return faFileArchive;
  if (ext === 'html' || ext === 'css' || ext === 'js' || ext === 'json') return faFileCode;
  return faFile;
}

function truncateName(name) {
  if (!name) return '';
  return name.length > 30 ? name.substring(0, 30) + '...' : name;
}

function ImportedFilesAssets(props) {
  const fileList = props.allFileListOfAssets || [];
  const [selectedAssets, setSelectedAssets] = useState([]);
  const [selectedFileObject, setSelectedFileObject] = useState();
  const [isInfoTabOpen, setIsInfoTabOpen] = useState(false);
  const [isOpengalleryPopUp, setIsOpengalleryPopUp] = useState(false);
  const [galleryAsset, setGalleryAsset] = useState();
  const [isDeletePopUpOPen, setIsDeletePopUpOPen] = useState(false);
  const [isDeleteConfirmPopUpOPen, setIsDeleteConfirmPopUpOPen] = useState(false);
  const [isCommentsPopUpOPen, setIsCommentsPopUpOPen] = useState(false);
  const [note, setNote] = useState('');
  const [noteList, setNoteList] = useState([]);
  const [assetsName, setAssetsName] = useState('');
  const [editedFileName, setEditedFileName] = useState('');
  const [isClickEditName, setIsClickEditName] = useState(false);
  const [downloading, setDownloading] = useState(false);
  const [carouselSlide, setCarouselSlide] = useState(0);

  const isAllSelected = fileList.length > 0 && selectedAssets.length === fileList.length;

  const handleSelectAsset = function (fileName, e) {
    if (e) e.stopPropagation();
    setSelectedAssets(function (prev) {
      if (prev.indexOf(fileName) !== -1) {
        return prev.filter(function (name) { return name !== fileName; });
      }
      return prev.concat([fileName]);
    });
  };

  const handleSelectAll = function (e) {
    if (e.target.checked) {
      setSelectedAssets(fileList.map(function (asset) { return asset.fileName; }));
    } else {
      setSelectedAssets([]);
    }
  };

  const downloadOneFile = function (url, name) {
    return fetch(url, {
      method: 'GET',
      referrerPolicy: 'no-referrer',
      cache: 'no-store',
    })
      .then(function (response) {
        if (!response.ok) throw new Error('Download failed');
        return response.blob();
      })
      .then(function (blob) {
        const blobUrl = URL.createObjectURL(blob);
        const downloadLink = document.createElement('a');
        downloadLink.href = blobUrl;
        downloadLink.download = name || 'downloaded_file';
        document.body.appendChild(downloadLink);
        downloadLink.click();
        document.body.removeChild(downloadLink);
        URL.revokeObjectURL(blobUrl);
      });
  };

  const handleDownloadSelected = function () {
    fileList
      .filter(function (asset) { return selectedAssets.indexOf(asset.fileName) !== -1; })
      .forEach(function (asset) {
        if (asset && asset.filePath) {
          downloadOneFile(asset.filePath, asset.actualFileName || asset.fileName)
            .catch(function (err) {
              console.error('Download failed for:', asset.actualFileName, err);
            });
        }
      });
  };

  const handleDownloadImage = function (url, fileObject) {
    setDownloading(true);
    downloadOneFile(url, (fileObject && fileObject.actualFileName) || 'downloaded_file')
      .catch(function (error) {
        console.error('Failed to download files:', error);
      })
      .then(function () {
        setDownloading(false);
      });
  };

  const handleSingleClick = function (asset) {
    setSelectedFileObject(asset);
    setEditedFileName('');
    setIsClickEditName(false);
    setIsInfoTabOpen(true);
  };

  const handleDoubleClick = function (asset) {
    setSelectedFileObject(asset);
    setGalleryAsset(asset);
    setEditedFileName('');
    setIsClickEditName(false);
    setIsOpengalleryPopUp(true);
    const index = fileList.findIndex(function (f) { return f.id === asset.id; });
    setCarouselSlide(index >= 0 ? Math.max(0, index - 2) : 0);
  };

  const getAssetNote = function (asset) {
    if (!asset) return;
    setIsCommentsPopUpOPen(true);
    setAssetsName(asset.actualFileName || '');
    getAssetNoteService(props.token, { assetDetails: asset.id }).then(function (res) {
      if (res) setNoteList(res);
    });
  };

  const addAssetNote = function () {
    if (!selectedFileObject) return;
    addAssetNoteService(props.token, {
      note: note,
      assetDetails: selectedFileObject.id,
    }).then(function (res) {
      if (res) {
        setNoteList(res.noteList);
        setNote('');
      }
    });
  };

  const handleRenameFileAssets = function () {
    setIsClickEditName(true);
    setEditedFileName(selectedFileObject ? selectedFileObject.actualFileName : '');
  };

  const handleSaveRename = function () {
    if (!editedFileName || !selectedFileObject) return;
    RenameFileAssetNewService(props.token, {
      fileId: selectedFileObject.id,
      newName: editedFileName,
      assetIdentifier: '',
      integerId: props.storeOverview.integerID,
      assetCategory: 3,
      subCategoryId: '',
    }).then(function (response) {
      if (response && response.fileList) {
        props.setAllFileListOfAssets(response.fileList);
        const updated = (response.fileList || []).find(function (f) {
          return f.id === selectedFileObject.id;
        });
        if (updated) {
          setSelectedFileObject(updated);
          if (galleryAsset && galleryAsset.id === updated.id) setGalleryAsset(updated);
        }
        setIsClickEditName(false);
        setEditedFileName('');
      }
    });
  };

  const handleDeleteFile = function () {
    if (!selectedFileObject) return;

    DeleteFileAssetNewService(props.token, {
      integerId: props.storeOverview.integerID,
      assetCategory: 3,
      subCategoryId: '',
      assetIdentifier: '',
      fileId: selectedFileObject.id,
      fileType: 'image',
    }).then(function (response) {
      if (response) {
        const deletedId = selectedFileObject.id;
        const deletedName = selectedFileObject.fileName;
        props.setAllFileListOfAssets(
          (props.allFileListOfAssets || []).filter(function (f) { return f.id !== deletedId; })
        );
        setSelectedAssets(function (prev) {
          return prev.filter(function (name) { return name !== deletedName; });
        });
        setSelectedFileObject();
        setGalleryAsset();
        setIsDeleteConfirmPopUpOPen(false);
        setIsDeletePopUpOPen(false);
        setIsInfoTabOpen(false);
        setIsOpengalleryPopUp(false);
      }
    });
  };

  const renderPreview = function (asset, options) {
    const opts = options || {};
    const name = (asset && (asset.actualFileName || asset.fileName)) || '';
    const mediaType = getMediaType(name);
    const style = opts.style || {
      width: '100%',
      height: opts.height || 140,
      objectFit: 'contain',
      background: '#f7f7f7',
      borderRadius: 4,
    };

    if (!asset) return null;

    if (mediaType === 'image') {
      return <img src={asset.filePath} alt="not found" style={style} />;
    }

    if (mediaType === 'video') {
      return (
        <video
          src={asset.filePath}
          controls={!!opts.controls}
          style={Object.assign({}, style, { background: '#000' })}
        />
      );
    }

    const ext = getExtension(name);
    const iconWrap = Object.assign({}, style, {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: '#fff',
    });

    if (EXCEL_EXTS.indexOf(ext) !== -1) {
      return (
        <div style={iconWrap}>
          <img src={xlsxIcon} alt="file" style={{ maxHeight: opts.iconSize || 72, maxWidth: opts.iconSize || 72 }} />
        </div>
      );
    }

    return (
      <div style={iconWrap}>
        <FontAwesomeIcon
          icon={getFileIcon(name)}
          style={{ fontSize: opts.iconSize || 56, color: '#6c757d' }}
        />
      </div>
    );
  };

  const renderCarouselStrip = function () {
    const visible = fileList.slice(carouselSlide, carouselSlide + 5);
    return (
      <div className="d-flex justify-content-center align-items-center">
        <button
          className="btn btn-primary prev-next"
          disabled={carouselSlide <= 0}
          onClick={function () { setCarouselSlide(Math.max(0, carouselSlide - 1)); }}
        >
          &lt;
        </button>
        {visible.map(function (asset) {
          const isActive = galleryAsset && galleryAsset.id === asset.id;
          return (
            <div
              key={asset.id || asset.fileName}
              className="p-2 mt-2 mb-1"
              style={{ backgroundColor: isActive ? '#D0EFB1' : '', cursor: 'pointer' }}
              onClick={function () {
                setGalleryAsset(asset);
                setSelectedFileObject(asset);
                setIsClickEditName(false);
                setEditedFileName('');
              }}
            >
              {renderPreview(asset, {
                height: 80,
                iconSize: 40,
                style: { width: 80, height: 80, objectFit: 'contain', background: '#f7f7f7' },
              })}
            </div>
          );
        })}
        <button
          className="btn btn-primary prev-next"
          disabled={carouselSlide >= Math.max(0, fileList.length - 5)}
          onClick={function () {
            setCarouselSlide(Math.min(Math.max(0, fileList.length - 5), carouselSlide + 1));
          }}
        >
          &gt;
        </button>
      </div>
    );
  };

  const activePreviewAsset = isOpengalleryPopUp ? galleryAsset : selectedFileObject;

  return (
    <>
      {fileList.length > 0 && (
        <Row className="d-flex align-items-center mb-2">
          <Col md={6}>
            <div className="d-flex align-items-center">
              <Input
                type="checkbox"
                id="importedSelectAllCheckbox"
                className="ml-1"
                checked={isAllSelected}
                onChange={handleSelectAll}
              />
              <span for="importedSelectAllCheckbox" className="mb-0 ml-4" style={{ cursor: 'pointer' }}>
                Select All ({selectedAssets.length} / {fileList.length})
              </span>
            </div>
          </Col>
          <Col md={6} className="d-flex justify-content-end">
            <Button
              color="primary"
              className="btn-background-color-Proceed-gallery"
              disabled={selectedAssets.length === 0}
              onClick={handleDownloadSelected}
            >
              Download
            </Button>
          </Col>
        </Row>
      )}

      <Row>
        <Col md={isInfoTabOpen ? 6 : 12}>
          <Row>
            {fileList.length === 0 ? (
              <Col md={12}>
                <p className="text-center text-muted mt-4 mb-4">No imported files found.</p>
              </Col>
            ) : (
              fileList.map(function (asset) {
                const isChecked = selectedAssets.indexOf(asset.fileName) !== -1;
                const isActive = selectedFileObject && selectedFileObject.id === asset.id && isInfoTabOpen;
                return (
                  <Col
                    key={asset.id || asset.fileName}
                    sm={4}
                    md={isInfoTabOpen ? 6 : 3}
                    onClick={function () { handleSingleClick(asset); }}
                    onDoubleClick={function () { handleDoubleClick(asset); }}
                  >
                    <Card
                      className="p-2 mt-2 mb-1"
                      style={{
                        backgroundColor: isActive ? '#D0EFB1' : '',
                        cursor: 'pointer',
                        position: 'relative',
                      }}
                    >
                      <Input
                        type="checkbox"
                        className="asset-checkbox"
                        style={{
                          position: 'absolute',
                          top: '10px',
                          right: '10px',
                          zIndex: 2,
                          cursor: 'pointer',
                        }}
                        checked={isChecked}
                        onChange={function (e) { handleSelectAsset(asset.fileName, e); }}
                        onClick={function (e) { e.stopPropagation(); }}
                      />
                      {renderPreview(asset)}
                      <p
                        className="text-center mt-2 mb-0"
                        title={asset.actualFileName}
                        style={{ fontSize: '13px' }}
                      >
                        {truncateName(asset.actualFileName)}
                      </p>
                    </Card>
                  </Col>
                );
              })
            )}
          </Row>
        </Col>

        {isInfoTabOpen && selectedFileObject && (
          <Col md={6} className="assets-card-sticky">
            <Card className="p-3 child-card">
              <div className="d-flex justify-content-end">
                <button
                  onClick={function () { setIsInfoTabOpen(false); }}
                  className="info-button-background-none"
                  title="Close"
                >
                  <FontAwesomeIcon icon={faTimes} />
                </button>
              </div>

              <p className="align-center">
                {renderPreview(selectedFileObject, {
                  height: 260,
                  iconSize: 96,
                  controls: getMediaType(selectedFileObject.actualFileName || selectedFileObject.fileName) === 'video',
                  style: {
                    width: '100%',
                    maxHeight: 320,
                    objectFit: 'contain',
                    background: '#f7f7f7',
                  },
                })}
              </p>

              <div className="d-flex align-items-center">
                {isClickEditName ? (
                  <>
                    <h6>
                      <Input
                        className="w-100"
                        type="text"
                        value={editedFileName || selectedFileObject.actualFileName}
                        onChange={function (e) { setEditedFileName(e.target.value); }}
                      />
                    </h6>
                    &nbsp;
                    <h6>
                      <button
                        title="save"
                        className="info-button-background-none"
                        onClick={handleSaveRename}
                        disabled={!editedFileName}
                      >
                        <img className="button-img-background-assets" src={TickMark} alt="not found" />
                      </button>
                      <button
                        title="Close"
                        className="info-button-background-none"
                        onClick={function () { setIsClickEditName(false); }}
                      >
                        <FontAwesomeIcon color="red" icon={faWindowClose} />
                      </button>
                    </h6>
                  </>
                ) : (
                  <>
                    <h6 title={selectedFileObject.actualFileName} className="file-name">
                      <b>{selectedFileObject.actualFileName}</b>&nbsp;
                    </h6>
                    <button
                      title="Edit"
                      className="info-button-background-none"
                      onClick={handleRenameFileAssets}
                    >
                      <img className="button-img-background-assets p-1" src={Rename} alt="not found" />
                    </button>
                  </>
                )}
                <button
                  onClick={function () {
                    handleDownloadImage(selectedFileObject.filePath, selectedFileObject);
                  }}
                  className="info-button-background-none mb-1"
                  disabled={downloading}
                  title="Download"
                >
                  <img
                    className={'p-1 ' + (downloading ? 'button-img-background-download-inprogress' : 'button-img-background-download')}
                    src={Download}
                    alt="not found"
                  />
                </button>
                {downloading ? <span>Downloading</span> : ''}
              </div>

              <div className="d-flex justify-content-between">
                <h6 className="d-flex justify-content-between">
                  <p>{selectedFileObject.fileSize || ''}</p>
                </h6>
                <p>
                  Last Modified on <b>{selectedFileObject.createdAt || ''}</b>
                </p>
              </div>

              {selectedFileObject.notes && (
                <p className="help-text-workflows mb-1 mt-3">
                  <b>Note :-</b>&nbsp;
                  <span className="issue-discription-set mb-0">{selectedFileObject.notes}</span>
                </p>
              )}

              <div className="d-flex justify-content-between">
                <div className="d-flex align-items-center">
                  <Button
                    onClick={function () { setIsDeletePopUpOPen(true); }}
                    className="delete-button-background-none mt-1"
                  >
                    <FontAwesomeIcon icon={faTrash} /> Delete
                  </Button>
                </div>
                <div className="ml-auto">
                  <button
                    onClick={function () { getAssetNote(selectedFileObject); }}
                    className="btn mt-1"
                  >
                    <img className="comments-bg-color" src={Comment_Dark} alt="not found" />
                  </button>
                </div>
              </div>
            </Card>
          </Col>
        )}
      </Row>

      <CustomModal
        isOpen={isOpengalleryPopUp}
        toggle={function () {
          setIsOpengalleryPopUp(!isOpengalleryPopUp);
          setIsClickEditName(false);
        }}
        size="lg"
        className="asset-carousel"
      >
        <Row className="m-1">
          <Col md={12}>
            {activePreviewAsset && (
              <div className="d-flex justify-content-between mb-2">
                <div className="d-flex align-items-center mb-2">
                  <h6 style={{ color: '#fff' }}>
                    <b>File Name : </b>&nbsp;
                  </h6>
                  {isClickEditName ? (
                    <>
                      <Input
                        className="w-50"
                        type="text"
                        value={editedFileName || activePreviewAsset.actualFileName}
                        onChange={function (e) { setEditedFileName(e.target.value); }}
                      />
                      &nbsp;
                      <h6>
                        <button
                          title="save"
                          className="info-button-background-none"
                          onClick={handleSaveRename}
                          disabled={!editedFileName}
                        >
                          <img className="carousel-img-background-none" src={TickMark} alt="not found" />
                        </button>
                        <button
                          title="Close"
                          className="info-button-background-none"
                          onClick={function () { setIsClickEditName(false); }}
                        >
                          <FontAwesomeIcon color="red" icon={faWindowClose} />
                        </button>
                      </h6>
                    </>
                  ) : (
                    <h6 style={{ color: '#fff' }}>
                      <b className="file-name">
                        {activePreviewAsset.actualFileName}&nbsp;
                      </b>
                      <button
                        title="Edit"
                        className="info-button-background-none"
                        onClick={handleRenameFileAssets}
                      >
                        <img className="carousel-img-background-none p-1" src={Rename} alt="not found" />
                      </button>
                    </h6>
                  )}
                  <h6>
                    <button
                      onClick={function () {
                        handleDownloadImage(activePreviewAsset.filePath, activePreviewAsset);
                      }}
                      className="info-button-background-none"
                      disabled={downloading}
                      title="Download"
                    >
                      <img className="carousel-img-background-none-download p-1" src={Download} alt="not found" />
                    </button>
                  </h6>
                </div>
                <div className="ml-auto">
                  <button
                    onClick={function () {
                      setIsOpengalleryPopUp(false);
                      setIsClickEditName(false);
                    }}
                    className="info-button-background-none"
                    title="Close"
                  >
                    <img src={Close} alt="not found" />
                  </button>
                </div>
              </div>
            )}

            <div className="file-view-div">
              {activePreviewAsset &&
                renderPreview(activePreviewAsset, {
                  controls: true,
                  iconSize: 120,
                  style: {
                    width: '100%',
                    maxHeight: 420,
                    objectFit: 'contain',
                    background: '#fff',
                  },
                })}
              <h6 className="d-flex justify-content-center delete-btn-popup">
                <Button
                  onClick={function () { setIsDeletePopUpOPen(true); }}
                  className="delete-button-background-none mt-1"
                >
                  <FontAwesomeIcon icon={faTrash} /> &nbsp; Delete
                </Button>
              </h6>
            </div>
          </Col>
          <Col md={12}>
            {renderCarouselStrip()}
          </Col>
        </Row>
      </CustomModal>

      <CustomModal
        isOpen={isDeletePopUpOPen}
        toggle={function () { setIsDeletePopUpOPen(!isDeletePopUpOPen); }}
        size="md"
        className="curve-popup"
      >
        <Card className="curve-popup p-3">
          <p>Do you want to delete this file?</p>
          <p><b>{selectedFileObject ? selectedFileObject.actualFileName : ''}</b></p>
          <div className="mb-2">
            <Button
              onClick={function () {
                setIsDeleteConfirmPopUpOPen(true);
                setIsDeletePopUpOPen(false);
              }}
              className="delete-button-background-none mt-1"
            >
              <FontAwesomeIcon icon={faTrash} /> &nbsp; Delete
            </Button>
            &nbsp;
            <Button onClick={function () { setIsDeletePopUpOPen(false); }} className="mt-1">
              Cancel
            </Button>
          </div>
        </Card>
      </CustomModal>

      <CustomModal
        isOpen={isDeleteConfirmPopUpOPen}
        toggle={function () { setIsDeleteConfirmPopUpOPen(!isDeleteConfirmPopUpOPen); }}
        size="md"
        className="curve-popup"
      >
        <Card className="curve-popup p-3">
          <p>Are you sure you want to delete this file?</p>
          <div className="mb-2">
            <Button onClick={handleDeleteFile} className="delete-button-background-none mt-1">
              <FontAwesomeIcon icon={faTrash} /> &nbsp; Confirm Delete
            </Button>
            &nbsp;
            <Button onClick={function () { setIsDeleteConfirmPopUpOPen(false); }} className="mt-1">
              Cancel
            </Button>
          </div>
        </Card>
      </CustomModal>

      <CustomModal
        isOpen={isCommentsPopUpOPen}
        toggle={function () { setIsCommentsPopUpOPen(false); }}
        size="md"
        header={<label title={assetsName} className="file-name">{assetsName}</label>}
        className="curve-popup position-of-pop-up"
      >
        <Row>
          <Col md={12} className="p-0">
            <div>
              {selectedFileObject && (
                <p className="align-center">
                  {renderPreview(selectedFileObject, {
                    height: 180,
                    iconSize: 72,
                    style: { width: '100%', maxHeight: 200, objectFit: 'contain' },
                  })}
                </p>
              )}
            </div>
          </Col>
          <Col md={12} className="scrollable-div p-0 overflow-auto" style={{ maxHeight: '187px' }}>
            {(noteList || []).map(function (item, index) {
              if (item.loggedInUser === 1) {
                return (
                  <div key={index} className="d-flex justify-content-end p-2">
                    <p className="p-2 mb-0 d-inline chat-background-color-sent">
                      {item.notes}<br />
                      <span className="float-right pt-1">{item.createdAt}</span>
                    </p>
                  </div>
                );
              }
              return (
                <div key={index} className="d-flex justify-content-start align-items-end p-2">
                  <div className="p-1 user-short-name">
                    {(item.userShortName || 'U').toUpperCase()}
                  </div>
                  <p className="d-inline p-2 mb-0 chat-background-color">
                    {item.notes}<br />
                    <span className="float-right pt-1">{item.createdAt}</span>
                  </p>
                </div>
              );
            })}
          </Col>
          <Col md={12} className="d-flex align-items-between pl-2 pr-2 pt-1">
            <Input
              className="w-100"
              placeholder="Add your comments"
              value={note}
              onChange={function (e) { setNote(e.target.value); }}
            />
            <button
              className="btn-background-color-comments"
              disabled={!note}
              onClick={addAssetNote}
            >
              <img src={Send} alt="not found" />
            </button>
          </Col>
        </Row>
      </CustomModal>
    </>
  );
}

const mapStateToProps = function (state) {
  return {
    token: state.loggedUser.token,
    storeOverview: state.accountOverview.store.storeOverview,
    UserPermission: state.accountOverview.store.StoreUserPermission,
  };
};

export default connect(mapStateToProps)(ImportedFilesAssets);
